import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

const VOTED_ITEMS_KEY = "roadmap_voted_items";

export const useRoadmapVoting = () => {
  const [votedItems, setVotedItems] = useState<Set<string>>(new Set());

  useEffect(() => {
    // Load voted items from localStorage
    const stored = localStorage.getItem(VOTED_ITEMS_KEY);
    if (stored) {
      setVotedItems(new Set(JSON.parse(stored)));
    }
  }, []);

  const hasVoted = (itemId: string) => votedItems.has(itemId);

  const vote = async (itemId: string, currentVotes: number) => {
    if (hasVoted(itemId)) {
      toast.error("You've already voted for this item");
      return false;
    }

    try {
      const { error } = await supabase
        .from("roadmap_items")
        .update({ votes: currentVotes + 1 })
        .eq("id", itemId);

      if (error) throw error;

      // Update local state
      const newVoted = new Set(votedItems).add(itemId);
      setVotedItems(newVoted);
      localStorage.setItem(VOTED_ITEMS_KEY, JSON.stringify([...newVoted]));

      toast.success("Vote recorded!");
      return true;
    } catch (error) {
      console.error("Error voting:", error);
      toast.error("Failed to record vote");
      return false;
    }
  };

  return { hasVoted, vote };
};
